import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import InsurancePathway from "@/pages/InsurancePathway";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Default route → insurance sponsor pathway */}
        <Route
          path="/"
          element={<Navigate to="/sponsor-pathway?mode=insurance" replace />}
        />
        <Route path="/sponsor-pathway" element={<InsurancePathway />} />
        <Route path="/insurance-pathway" element={<InsurancePathway />} />
        <Route
          path="*"
          element={<Navigate to="/sponsor-pathway?mode=insurance" replace />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
